import { __awaiter } from "tslib";
import { DEFAULT_OPTIONS } from '../common/getApiUrl';
import consoleEvents from '../consoleEvents';
import request, { getWAFWhitelistingHeader, getWhitelistingHeader, getCookieHeader, getMaintenanceHeader, } from '../request';
import { LoadingStates } from '../request/constants';
import { getStoredAemLabels, getStoredHybrisLabels, getStoredLslLabels, setAemLabelsOnStorage, setHybrisLabelsOnStorage, fetchLslLabels, } from './helpers';
import { clearLabelsCache } from './helpers/getLabelsFromStorage';
var LabelsSource;
(function (LabelsSource) {
    LabelsSource["Aem"] = "aemLabels";
    LabelsSource["Hybris"] = "hybrisLabels";
    LabelsSource["Lsl"] = "lslLabels";
})(LabelsSource || (LabelsSource = {}));
const fetchHybrisLabels = (shouldStoreDataInClientStorage, customLocale, cookie, hasMaintenanceHeader, ssrLogger) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield request.get('labels', {
            use: { locale: DEFAULT_OPTIONS.use.locale || !!customLocale },
            customLocale,
            headers: Object.assign(Object.assign(Object.assign(Object.assign({}, getWhitelistingHeader()), getWAFWhitelistingHeader()), getCookieHeader(cookie)), (hasMaintenanceHeader && getMaintenanceHeader())),
        });
        if (shouldStoreDataInClientStorage) {
            setHybrisLabelsOnStorage(response === null || response === void 0 ? void 0 : response.data, customLocale);
        }
        clearLabelsCache();
        ssrLogger === null || ssrLogger === void 0 ? void 0 : ssrLogger.info(response, 'fetchHybrisLabels success');
        return response === null || response === void 0 ? void 0 : response.data;
    }
    catch (e) {
        consoleEvents.error(e);
        ssrLogger === null || ssrLogger === void 0 ? void 0 : ssrLogger.error(e, 'fetchHybrisLabels error');
        return {};
    }
});
const fetchAemLabels = (shouldStoreDataInClientStorage, customLocale, hasMaintenanceHeader, ssrLogger) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield request.get('i18n.json', {
            use: { apiVersion: false, locale: DEFAULT_OPTIONS.use.locale || !!customLocale },
            customLocale,
            headers: Object.assign(Object.assign(Object.assign({}, getWhitelistingHeader()), getWAFWhitelistingHeader()), (hasMaintenanceHeader && getMaintenanceHeader())),
        });
        if (shouldStoreDataInClientStorage) {
            setAemLabelsOnStorage(response === null || response === void 0 ? void 0 : response.data, customLocale);
        }
        ssrLogger === null || ssrLogger === void 0 ? void 0 : ssrLogger.info(response, 'fetchAemLabels success');
        return response === null || response === void 0 ? void 0 : response.data;
    }
    catch (e) {
        consoleEvents.error(e);
        ssrLogger === null || ssrLogger === void 0 ? void 0 : ssrLogger.error(e, 'fetchAemLabels error');
        return {};
    }
});
const fetchLabels = (setFetchingLabelState, locale, lslUserId, shouldStoreDataInClientStorage = true, lslFile = '', cookies = '', hasMaintenanceHeader, ssrLogger) => __awaiter(void 0, void 0, void 0, function* () {
    const isAemLabelsEnabled = process.env.IS_I18N_LABELS_ENABLED === 'enabled';
    const storedAemLabels = getStoredAemLabels(locale);
    const storedHybrisLabels = getStoredHybrisLabels(locale);
    const storedLslLabels = !!lslUserId && getStoredLslLabels(lslUserId, locale, lslFile);
    const shouldFetchAemLabels = isAemLabelsEnabled && !storedAemLabels;
    if (setFetchingLabelState)
        setFetchingLabelState(LoadingStates.Loading);
    const results = yield Promise.all([
        ...(shouldFetchAemLabels
            ? [fetchAemLabels(shouldStoreDataInClientStorage, locale, hasMaintenanceHeader, ssrLogger)]
            : [{}]),
        ...(!storedHybrisLabels
            ? [
                fetchHybrisLabels(shouldStoreDataInClientStorage, locale, cookies, hasMaintenanceHeader, ssrLogger),
            ]
            : [{}]),
        ...(!storedLslLabels
            ? [
                fetchLslLabels(locale, lslUserId, shouldStoreDataInClientStorage, lslFile, hasMaintenanceHeader, ssrLogger),
            ]
            : [{}]),
    ]);
    if (setFetchingLabelState)
        setFetchingLabelState(LoadingStates.LoadedSuccess);
    const result = {
        hybrisLabels: shouldStoreDataInClientStorage && storedHybrisLabels ? storedHybrisLabels : results[1],
        lslLabels: (shouldStoreDataInClientStorage && storedLslLabels ? storedLslLabels : results[2]) ||
            undefined,
    };
    if (isAemLabelsEnabled) {
        result.aemLabels =
            shouldStoreDataInClientStorage && !shouldFetchAemLabels ? storedAemLabels : results[0];
    }
    return result;
});
export default fetchLabels;
//# sourceMappingURL=fetchLabels.js.map